/**
 * FAIR Dialog — DS Large overlays › Modal (324:6670)
 */

export const FAIR_DIALOG_CONTENT_TYPES = ['text'] as const
export type FairDialogContentType = (typeof FAIR_DIALOG_CONTENT_TYPES)[number]

/** DS Modal Size=Default (324:4917). */
export const FAIR_DIALOG_DEFAULT_WIDTH = '440px'
